import { createSlice } from '@reduxjs/toolkit'


export const carsSlice = createSlice({
    name: 'cars',
    initialState: {
        carsData: [],
    },
    reducers: {
        getCars: (state, action) => {
          return {...state, carsData: [...action.payload]}
        },
        putCars: (state, action) => {
            state.carsData = action.payload
        },
    },
})

export const { getCars, putCars } = carsSlice.actions;
export const carsData = state => state?.cars?.carsData;
export default carsSlice.reducer;